import PropTypes from 'prop-types';

export const discount = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  assignment: PropTypes.string,
});
export const discounts = PropTypes.arrayOf(discount);
export const handler = PropTypes.func;
export const edit = PropTypes.bool;
export const pristine = PropTypes.bool;
export const submitting = PropTypes.bool;
export const valid = PropTypes.bool;
export const url = PropTypes.string;
export const string = PropTypes.string;
export const flag = PropTypes.bool;
